// extracted by mini-css-extract-plugin
export default {"version":"Version-module_version__3Md3-","versionInfo":"Version-module_versionInfo__3CWKY"};